import * as React from "react";
import Modal from "../../ui/modal/Modal";
import Input from "../../../hiberUiKit/src/atoms/Input/Input";
import ButtonSecondary from "../../../hiberUiKit/src/atoms/Buttons/ButtonSecondary";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import "./workspaceModal.scss";

interface IProps {
	viewName: string;
	onClose: () => void;
	onSave: (viewName: string) => void;
}

interface IState {
	inputText: string;
	isLoading: boolean;
}

export default class CopyViewModal extends React.PureComponent<IProps, IState> {

	constructor(props: IProps) {
		super(props);

		this.state = {inputText: `Copy of ${props.viewName}`, isLoading: false};
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onClose}
				   title={<span>Duplicate <strong>{this.props.viewName}</strong></span>}
				   autoWidth
				   customClass={"c-workspace-modal"}>
				<div className={"c-input-box"}>
					<Input type={"text"} value={this.state.inputText}
						   onChange={(e) => this.setState({inputText: e.target.value})}
						   focus/>
				</div>
				<div className={"c-buttons-box"}>
					<ButtonSecondary label={"Cancel"} onClick={this.props.onClose}/>
					<ButtonPrimary label={"Duplicate"}
								   onClick={() => this.setState({isLoading: true}, () => this.props.onSave(this.state.inputText))}
								   disabled={!this.state.inputText || this.state.isLoading}
								   isLoading={this.state.isLoading}/>
				</div>
			</Modal>
		)
	}
}